import { MyPolicies } from 'types/life';
import { changeDataFun } from 'utils/formate';

export interface MyPoliciesProps {
  productCategory: string;
  productCategoryUrl: string;
  productCategoryTitle: string;
  productName: string;
  policyStatusCode: string;
  policyStatus: string;
  alertStateCode: string;
  alertState: string;
  policyNumber: string;
  insuredName: string;
  premiumDueDate?: string;
  companyCode: string;
  orderNo: string;
  colour: string;
  salesUnitCode?: string;
  premiumDueDateBefore?: string;
  premCessationDate?: string;
  planCode?: string;
  alertPolicyUpdateStateCode?: string;
  alertPolicyUpdateStateName?: string;
}
const MAXIMUM_NUMBER_OF_NEWS = 4;

export const formatPolicy = (
  policies: MyPolicies[] | undefined,
  isEnglish: boolean,
  length?: number,
  //   token: string,
): MyPoliciesProps[] | undefined => {
  if (!policies) return undefined;
  const formattedPolicies = policies.map((policy) => {
    const {
      productCategory,
      productCategoryUrl,
      productCategoryEn,
      productCategoryTC,
      productName,
      productNameTc,
      policyStatusCode,
      policyStatus,
      policyStatusTc,
      alertStateCode,
      alertState,
      alertStateTc,
      policyNumber,
      insuredName,
      premiumDueDate,
      companyCode,
      orderNo,
      colour,
      salesUnitCode,
      premCessationDate,
      planCode,
      alertPolicyUpdateStateCode,
      alertPolicyUpdateState,
      alertPolicyUpdateStateTc,
    } = policy;
    return {
      productCategory,
      productCategoryUrl,
      productCategoryTitle: isEnglish ? productCategoryEn : productCategoryTC,
      productName: isEnglish ? productName : productNameTc,
      policyStatusCode,
      policyStatus: isEnglish ? policyStatus : policyStatusTc,
      alertStateCode,
      alertState: isEnglish ? alertState : alertStateTc,
      policyNumber,
      insuredName,
      premiumDueDate: isEnglish ? premiumDueDate : changeDataFun(premiumDueDate),
      companyCode,
      orderNo: orderNo || '',
      colour,
      salesUnitCode,
      premCessationDate: isEnglish ? premCessationDate : changeDataFun(premCessationDate),
      planCode,
      alertPolicyUpdateStateCode: alertPolicyUpdateStateCode,
      alertPolicyUpdateStateName: isEnglish ? alertPolicyUpdateState : alertPolicyUpdateStateTc,
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedPolicies.slice(0, length ? length : MAXIMUM_NUMBER_OF_NEWS);
};

export const formatSinglePolicy = (policy: MyPolicies | undefined, isEnglish: boolean): MyPoliciesProps | undefined => {
  if (!policy) return undefined;
  const {
    productCategory,
    productCategoryUrl,
    productCategoryEn,
    productCategoryTC,
    productName,
    productNameTc,
    policyStatusCode,
    policyStatus,
    policyStatusTc,
    alertStateCode,
    alertState,
    alertStateTc,
    policyNumber,
    insuredName,
    premiumDueDate,
    companyCode,
    orderNo,
    planCode,
    colour,
    alertPolicyUpdateStateCode,
    alertPolicyUpdateState,
    alertPolicyUpdateStateTc,
  } = policy;
  return {
    productCategory,
    productCategoryUrl,
    productCategoryTitle: isEnglish ? productCategoryEn : productCategoryTC,
    productName: isEnglish ? productName : productNameTc,
    policyStatusCode,
    policyStatus: isEnglish ? policyStatus : policyStatusTc,
    alertStateCode,
    alertState: isEnglish ? alertState : alertStateTc,
    policyNumber,
    insuredName,
    premiumDueDate: isEnglish ? premiumDueDate : changeDataFun(premiumDueDate),
    companyCode,
    orderNo: orderNo || '',
    colour,
    planCode,
    premiumDueDateBefore: premiumDueDate,
    alertPolicyUpdateStateCode: alertPolicyUpdateStateCode,
    alertPolicyUpdateStateName: isEnglish ? alertPolicyUpdateState : alertPolicyUpdateStateTc,
  };
};
